<template>
	<div>
		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteUserConfirm();
			" />

		<v-data-table
			dense
			:items="filteredBillings"
			:headers="headers"
			:height="pageHeight(174)"
			class="medical-staff-data-table"
			:loading="loading"
			:headers-length="headers.length"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			sort-by="id"
			item-key="id"
			fixed-header
			:footer-props="getDataTableFooterProps('userBillingSettingTable')"
			:items-per-page="-1">
			<template v-slot:item="{ item, index }">
				<tr :class="getRowsForDataTable(index)">
					<td class="text-left font-weight-medium font-size12-5">
						{{ item.userFullname }}
					</td>
					<td class="text-left font-weight-medium font-size12-5">
						{{ item.roleId === 4 ? $t('nurse') : item.roleId === 7 ? $t('caregiver') : $t('doctor') }}
					</td>
					<td class="text-left font-weight-medium font-size12-5">
						{{ item.officeName }}
					</td>
					<!--        <td class="text-left font-size12">-->
					<!--          {{ item.organizationName }}-->
					<!--        </td>-->
					<td>
						<div class="d-flex align-center justify-end">
							<v-menu left bottom class="py-0" offset-y transition="slide-x-transition">
								<template v-slot:activator="{ on, attrs }">
									<v-btn small icon color="black" v-bind="attrs" v-on="on">
										<span class="mdi mdi-18px mdi-dots-horizontal"></span>
									</v-btn>
								</template>

								<v-list class="px-0" dense>
									<v-list-item class="py-0 my-0" link dense @click="handleActionEdit(item)">
										<v-list-item-icon class="mx-1">
											<v-icon class="icon-img mdi-18px" color="black">mdi-pencil</v-icon>
										</v-list-item-icon>
										<v-list-item-content class="font-bold font-size14">{{ $t('edit') }}</v-list-item-content>
									</v-list-item>
									<v-divider />
									<v-list-item
										v-if="
											roleName === 'SYSTEM_ADMIN' || roleName === 'SYSTEM_USER' || roleName === 'ORGANIZATION_ADMIN'
										"
										link
										dense
										@click="handleActionDelete(item)">
										<v-list-item-icon class="mx-1">
											<v-icon color="red">mdi-trash-can-outline</v-icon>
										</v-list-item-icon>
										<v-list-item-content class="font-bold font-size14">{{ $t('delete') }}</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getDataTableFooterProps, getRowsForDataTable, showErrorAlert, showSuccessAlert } from '@/utils/utilities';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	components: { DeleteDialog },
	data () {
		return {
			showDeleteDialog: false,
			selectedItem: {},
			seach: null,
			loading: false,
			headers: [
				{ text: this.$t('name'), sortable: false, class: 'secondary', align: 'start' },
				{ text: this.$t('role'), sortable: false, class: 'secondary' },
				{ text: this.$t('location'), sortable: false, class: 'secondary' },
				{ text: this.$t('actions'), sortable: false, class: 'secondary', align: 'end' },
			],
		};
	},
	computed: {
		...mapState({
			billingTemplatesAll: (state) => state.usersbillingsauthorization.billingTemplatesAll,
		}),
		...mapGetters({
			appBarSearch: 'filterbar/getSearch',
			roleName: 'authentication/getRole',
			pageHeight: 'pageHeight',
		}),
		filteredBillings () {
			const searchTerm = this.appBarSearch ? this.appBarSearch.toLowerCase() : '';
			return this.billingTemplatesAll.filter((item) => {
				const username = item.userFullname && item.userFullname ? item.userFullname.toLowerCase() : '';
				return username.includes(searchTerm);
			});
		},
	},
	methods: {
		getRowsForDataTable,
		getDataTableFooterProps,
		handleActionEdit (item) {
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', item);
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'user billings',
			});
			this.$store.dispatch('usersbillingsauthorization/getusersbillingsauthorizationbyid', item.id);
		},
		async handleActionDelete (item) {
			this.showDeleteDialog = true;
			this.selectedItem = item;
		},
		async deleteUserConfirm () {
			await this.$store
				.dispatch('usersbillingsauthorization/deletebillingusersauthorization', this.selectedItem.id)
				.then((res) => {
					if (res) {
						showSuccessAlert(this.$t('success-operation'));
					} else {
						showErrorAlert(this.$t('failed-operation'));
					}
					this.billinguserauthorization();
					this.closeDeleteDialog();
				});
		},
		closeDeleteDialog () {
			this.showDeleteDialog = false;
			this.selectedItem = {};
		},
		billinguserauthorization () {
			this.loading = true;
			this.$store.dispatch('usersbillingsauthorization/billinguserauthorizationV1').then((res) => {
				this.loading = false;
			});
		},
	},
	mounted () {
		this.billinguserauthorization();
	},
};
</script>
